import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { forkJoin } from 'rxjs';

import { ApiService } from '../../core/api.service';

@Component({
    selector: 'app-home-dashboard',
    standalone: true,
    imports: [CommonModule, ButtonModule],
    template: `
        <!-- Summary cards -->
        <div class="grid grid-cols-12 gap-6 mb-8">
            <div class="col-span-12 lg:col-span-6 xl:col-span-3">
                <div class="card mb-0 cursor-pointer hover:shadow-lg transition-shadow" (click)="go('/fuel-dispatch')">
                    <div class="flex justify-between">
                        <div>
                            <span class="block text-muted-color font-medium mb-3">Fuel Dispatch Records</span>
                            <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ fuelCount }}</div>
                        </div>
                        <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border" style="width: 3rem; height: 3rem">
                            <i class="pi pi-truck text-blue-500 text-2xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 xl:col-span-3">
                <div class="card mb-0 cursor-pointer hover:shadow-lg transition-shadow" (click)="go('/sales')">
                    <div class="flex justify-between">
                        <div>
                            <span class="block text-muted-color font-medium mb-3">Sales Records</span>
                            <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ salesCount }}</div>
                        </div>
                        <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border" style="width: 3rem; height: 3rem">
                            <i class="pi pi-chart-line text-cyan-500 text-2xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 xl:col-span-3">
                <div class="card mb-0 cursor-pointer hover:shadow-lg transition-shadow" (click)="go('/companies')">
                    <div class="flex justify-between">
                        <div>
                            <span class="block text-muted-color font-medium mb-3">Companies</span>
                            <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ companyCount }}</div>
                        </div>
                        <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border" style="width: 3rem; height: 3rem">
                            <i class="pi pi-building text-orange-500 text-2xl"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 xl:col-span-3">
                <div class="card mb-0 cursor-pointer hover:shadow-lg transition-shadow" (click)="go('/users')">
                    <div class="flex justify-between">
                        <div>
                            <span class="block text-muted-color font-medium mb-3">Users</span>
                            <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ userCount }}</div>
                        </div>
                        <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border" style="width: 3rem; height: 3rem">
                            <i class="pi pi-users text-purple-500 text-2xl"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Quick actions -->
        <div class="card">
            <div class="font-semibold text-xl mb-4">Quick Actions</div>
            <div class="flex flex-wrap gap-3">
                <p-button label="Fuel Dispatch" icon="pi pi-truck" (onClick)="go('/fuel-dispatch')"></p-button>
                <p-button label="Sales Report" icon="pi pi-chart-line" severity="info" (onClick)="go('/sales')"></p-button>
                <p-button label="Companies" icon="pi pi-building" severity="warn" (onClick)="go('/companies')"></p-button>
                <p-button label="Suppliers" icon="pi pi-briefcase" severity="secondary" (onClick)="go('/suppliers')"></p-button>
                <p-button label="Users" icon="pi pi-users" severity="help" (onClick)="go('/users')"></p-button>
            </div>
        </div>
    `
})
export class HomeDashboard implements OnInit {
    fuelCount = 0;
    salesCount = 0;
    companyCount = 0;
    userCount = 0;

    constructor(private api: ApiService, private router: Router, private cd: ChangeDetectorRef) {}

    ngOnInit(): void {
        // counts laao (page=1, pageSize=1 -> sirf total chahiye)
        forkJoin({
            fuel: this.api.getList(null, 1, 1, ''),
            sales: this.api.getSalesList(null, 1, 1, ''),
            companies: this.api.getAllCompanies(),
            users: this.api.getUsers()
        }).subscribe({
            next: (res) => {
                this.fuelCount = res.fuel.total;
                this.salesCount = res.sales.total;
                this.companyCount = res.companies.length;
                this.userCount = res.users.length;
                this.cd.detectChanges();
            },
            error: () => { /* silently ignore */ }
        });
    }

    go(path: string): void { this.router.navigate([path]); }
}
